import { createFileRoute } from "@tanstack/react-router";
import { TopHeader } from "@/components/TopHeader";
import { BottomNavigation } from "@/components/BottomNavigation";
import { AGREEMENT_TYPES } from "@/lib/mock-data";
import { FileSignature } from "lucide-react";

export const Route = createFileRoute("/legal-info")({
  head: () => ({
    meta: [
      { title: "Legal & agreements · Landoo" },
      { name: "description", content: "Overview of Landoo's legal agreements and declarations." },
      { property: "og:title", content: "Legal & agreements · Landoo" },
      { property: "og:description", content: "Landoo agreements and declarations." },
    ],
  }),
  component: LegalPage,
});

function LegalPage() {
  return (
    <div className="flex min-h-screen flex-col bg-cream/30 pb-20 md:pb-0">
      <TopHeader />
      <main className="mx-auto w-full max-w-3xl flex-1 space-y-6 p-4 md:p-6">
        <div>
          <h1 className="text-2xl font-bold text-brown-dark">Legal information</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Landoo captures signed declarations from every partner and consent from customers. Full
            agreement content will be provided at signing.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          {AGREEMENT_TYPES.map((a) => (
            <div
              key={a}
              className="flex items-start gap-3 rounded-2xl border border-border bg-card p-4 shadow-soft"
            >
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-brand-soft text-brown-dark">
                <FileSignature className="h-4 w-4" />
              </div>
              <div>
                <div className="text-sm font-semibold text-brown-dark">{a}</div>
                <div className="text-[11px] text-muted-foreground">
                  Placeholder — content to be finalised.
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
      <BottomNavigation />
    </div>
  );
}
